import { QUERY_CACHE_USER_ACCOUNT } from '../../query/user/queryUserAccount';

export default {
  updateCacheAccount: (_, variables, { cache }) => {
    const prev = cache.readQuery({
      query: QUERY_CACHE_USER_ACCOUNT,
      variables: { id: variables.id }
    });
    const newUser = {
      ...prev,
      user: { ...prev.user, ...variables },
      __typename: 'UsersPermissionsUser'
    };
    cache.writeQuery({
      query: QUERY_CACHE_USER_ACCOUNT,
      data: newUser
    });
  }
};
